import { jsx as l } from "react/jsx-runtime";
const r = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M25.521 14.35v26.044a9.705 9.705 0 0 0-5.757-1.885c-5.38 0-9.758 4.377-9.758 9.757s4.377 9.758 9.758 9.758c5.38 0 9.757-4.377 9.757-9.758V26.24l20.473-5.687v13.14a9.706 9.706 0 0 0-5.758-1.884c-5.38 0-9.757 4.377-9.757 9.757s4.377 9.758 9.757 9.758 9.758-4.377 9.758-9.758V6.555L25.521 14.35Zm-5.757 39.674a5.764 5.764 0 0 1-5.758-5.758 5.764 5.764 0 0 1 5.758-5.757 5.764 5.764 0 0 1 5.757 5.757 5.764 5.764 0 0 1-5.757 5.758Zm24.472-6.7a5.764 5.764 0 0 1-5.757-5.758 5.764 5.764 0 0 1 5.757-5.757 5.764 5.764 0 0 1 5.758 5.757 5.764 5.764 0 0 1-5.758 5.758Zm5.758-28.847-20.473 5.687v-1.538l20.473-5.687v1.538Zm0-3.614L29.521 20.55v-3.148l20.473-5.605v3.066Z"
      }
    )
  }
);
export {
  r as Music
};
